<template>
  <div class="d-flex">

    <left-menu v-if="authStateStore.userAuthenticated" v-model="showMenu"></left-menu>

    <div class="main-container block-center w-100">


      <div class="bg-container">
        <div class="bg-clouds"></div>
        <div class="bg-grass"></div>
        <div class="bg-sun"></div>
      </div>

      <v-expand-transition>
        <cloud-text v-if="firstLoad">
          <h1 class="h1 color-corp">Предварительная загрузка</h1>
        </cloud-text>
        <div v-else class="wrapper mt-large w-100">
          <v-app app class="main-container">
            <div class="mb-large">
              <v-expand-transition>
                <div v-if="authStateStore.userAuthenticated" class="mb-large">
                  <base-container variant="no-padding">
                    <v-toolbar dense floating color="transparent">
                      <v-app-bar-nav-icon
                        color="secondary"
                        @click="showMenu = !showMenu"
                      ></v-app-bar-nav-icon>

                      <v-toolbar-title v-if="adaptiveBreakpoint">
                        <h3 class="color-corp text-truncate">
                          {{ userDataStore.fullName }}
                        </h3>
                      </v-toolbar-title>

                      <router-link to="/profile/" class="ml-auto">
                        <v-btn v-if="adaptiveBreakpoint" icon>
                          <v-icon color="secondary">
                            {{
                              pageIsProfile
                                ? "mdi-account-circle"
                                : "mdi-account-circle-outline"
                            }}
                          </v-icon>
                        </v-btn>
                        <v-btn v-else icon :size="42" variant="text" class="profile-btn-box-shadow">
                          <h3 class="color-corp">{{ userDataStore.userFirstName?.[0] ?? '' }}</h3>
                        </v-btn>
                      </router-link>

                      <v-btn icon @click="logout()">
                        <v-icon color="secondary">mdi-export</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </base-container>
                </div>
              </v-expand-transition>

              <v-main>
                <router-view v-slot="{ Component }">
                  <v-expand-transition>
                    <component :is="Component"></component>
                  </v-expand-transition>
                </router-view>
              </v-main>
            </div>
          </v-app>
        </div>
      </v-expand-transition>
    </div>

  </div>
</template>
<script>
import {computed, onBeforeMount, onMounted, onUnmounted, ref} from "vue";
import {GSAP} from "@/plugins/gsap";
import {useRoute, useRouter} from "vue-router";
import {useUserDataStore} from "@/store/userData";
import {useAuthStateStore} from "@/store/authData";
import CloudText from "@/components/CloudText";
import BaseContainer from "@/layouts/BaseContainer";
import {routes} from "@/router";
import {apiService} from "@/services/api/apiService";
import LeftMenu from "@/components/LeftMenu.vue";
import {API_Authorization_logout} from "@/services/api/Authorization/logout";
import {notifyError} from "@/plugins/notification";

export default {
  components: {
    LeftMenu,
    CloudText,
    BaseContainer
  },
  setup() {
    const router = useRouter();

    const userDataStore = useUserDataStore();
    const authStateStore = useAuthStateStore();

    const firstLoad = ref(true);

    const updateUserData = () => {
      userDataStore
        .getUserData()
        .catch(() => router.push("/auth/"))
        .finally(() => (firstLoad.value = false));
    };

    onBeforeMount(() => updateUserData());

    const userName = ref("userName");
    const route = useRoute();

    const menuList = ref(
      routes
        .filter((e) => e.meta?.menuLabel)
        .map((e) => {
          if (e.meta?.menuLabel) {
            return {
              label: e.meta.menuLabel,
              link: e.path
            };
          }
        })
    );

    const pageIsProfile = computed(() => route.name === "profile");

    onBeforeMount(() => {
      GSAP.fromTo(
        userName.value,
        {
          x: 100,
          opacity: 0
        },
        {
          x: 0,
          opacity: 1,
          duration: 2,
          ease: "elastic"
        }
      );
    });
    const showMenu = ref(true);

    const windowWidth = ref(window.innerWidth)
    const adaptiveBreakpoint = computed(() => (windowWidth.value > 634))

    function handleResize() {
      windowWidth.value = window.innerWidth
    }

    onMounted(() => {
      window.addEventListener('resize', handleResize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
    })
    return {
      authStateStore,
      userDataStore,
      firstLoad,

      menuList,
      showMenu,

      logout: () => {
        API_Authorization_logout()
          .then(() => {
            authStateStore.$reset();
            userDataStore.$reset();
            apiService.clearAuth();
            router.push("/auth/");
          })
          .catch((err) => {
            notifyError("Ошибка при выходе из аккаунта. попробуйте снова.");

          })
      },

      pageIsProfile,

      windowWidth,
      adaptiveBreakpoint,

      drawer: ref(true)
    };
  }
};
</script>
<style lang="scss">

.profile-btn-box-shadow {
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 0px 3x 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
}

:root {
  --border-radius-base: 16px;
}


.v-application {
  background-color: transparent !important;
}

.v-expansion-panel {
  background: var(--color-corp-gradient);
  color: var(--color-white-blue);
  border-radius: 20px;
}

.v-expansion-panel-title {
  color: var(--color-white);
}

v-skeleton-loader__text {
  margin: 0;
}

.user-name {
  //color: var(--color-white);
  //text-shadow: 0 0 10px black;
}

@keyframes bg-to-right {
  0% {
    background-position-x: 0;
  }
  100% {
    background-position-x: 512px;
  }
}

@keyframes sun-pulse {
  0% {
    background-size: 100%;
  }
  50% {
    background-size: 70%;
  }
  100% {
    background-size: 100%;
  }
}

.main-container {
  padding: 0.05em;
  position: relative;
  min-height: 100vh;
}

.bg-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
  background-color: #185873;

  & > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.bg-grass {
  font-family: "Lato", sans-serif;
  background-color: var(--color-white-blue);
  //background: var(--color-white-blue);
  //background: linear-gradient(148deg, var(--color-corp-light) 0%, var(--color-white-blue) 100%);
  //background-size: 200%;
}

/*
.bg-sun {
  background-image: url("./assets/img/sun.png");
  background-size: 100%;
  background-repeat: no-repeat;

  background-position-x: right;
  background-position-y: top;

  animation: sun-pulse 20s ease-in-out infinite;
}

.bg-grass {
  background-image: url("./assets/img/grass.png");
  background-color: unset;
  background-position: bottom;
  background-size: contain;
  background-repeat: no-repeat;
}

.bg-clouds {
  width: 100%;
  height: 100%;
  //width: 200% !important;
  //margin-left: -50%;
  //height: 130% !important;
  //
  //transform: perspective(80vw) rotateX(-5deg);
  background-image: url(./assets/img/clouds.png);
  background-repeat: repeat;
  background-position-x: 0;

  animation: bg-to-right 30s linear infinite;
  animation-fill-mode: revert;
  // animation-direction: alternate-reverse;
}*/
.left-navigation-drawer {
  transition: all .3s ease-in-out;
}

.left-navigation-drawer--active {
  // margin-right: 200px;
}


</style>
